import { ErrorToast, SuccessToast } from "../components/toastify";
import { AxiosPostMethod } from "../helpers/customAxios";
import HandleLogout from "./handleLogout";

/**
 * API CALL: Add Event Services (Voice Call, SMS, Custom List)
 * 
 * Endpoint: org/event/add-service
 * 
 * Backend Logic Should:
 * 1. Receive event_id, reminder_voice, reminder_sms, etc.
 * 2. If has_custom_list = 1 and custom_list_locations provided:
 *    - Query user_info table WHERE city IN (custom_list_locations) OR village IN (custom_list_locations)
 *    - Get mobile numbers matching those cities/villages
 *    - Insert each mobile number into event_automation_list with event_id
 * 3. If custom_list_file provided:
 *    - Parse Excel file and extract mobile numbers from "Mobile Number" column
 *    - Insert into event_automation_list with event_id
 * 4. Insert voice call/SMS configuration into event_reminders table
 * 5. Update credits in wallet based on voice_call_credits
 */
const HandleAddEventService = async (body) => {
  console.log("🔄 API CALL: org/event/add-service");
  console.log("📤 Request Body:", body);
  console.log("\n=== EXPECTED BACKEND OPERATIONS ===");
  console.log("1️⃣  Insert reminder configuration (voice/SMS)");
  console.log("2️⃣  Process custom list:");
  console.log("   - If locations selected: Match cities from user_info table");
  console.log("   - If Excel file: Extract mobile numbers from file");
  console.log("   - Insert mobile numbers into event_automation_list");
  console.log("3️⃣  Deduct voice_call_credits from wallet");
  console.log("=====================================\n");

  const AddRes = await AxiosPostMethod(
    "org/event/add-service",
    body,
    false,
    true
  );

  console.log("📥 API Response Status:", AddRes?.status);
  console.log("📥 API Response Data:", AddRes?.data);

  if (AddRes.status === 200) {
    console.log("✅ SUCCESS: Services added to event_automation_list");
    console.log("\n=== VERIFY IN DATABASE ===");
    console.log("✓ Check event_automation_list table");
    console.log("  Query: SELECT * FROM event_automation_list WHERE event_id = ?");
    console.log("✓ Check event_reminders table for voice/SMS config");
    console.log("✓ Check wallet table for credit deduction");
    console.log("============================\n");
    return true;
  } else {
    if (AddRes.status === 401) {
      console.error("❌ Unauthorized - Session expired");
      HandleLogout();
    } else {
      console.error("❌ API Error - Status:", AddRes?.status);
      console.error("❌ Error Message:", AddRes?.data?.message);
    }
    ErrorToast("Can't add services, please try again after sometime");
    return null;
  }
};

export default HandleAddEventService;

